module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sys_tip_outer"
  }, [_c('div', {
    staticClass: "quick-tpis"
  }, [_c('marquee', {
    attrs: {
      "behavior": "scroll",
      "onmouseover": "this.stop()",
      "onmouseout": "this.start()"
    }
  }, [_vm._v(_vm._s(_vm.config_info.notice) + "   ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64738cd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/affiche/affiche.vue
// module id = 628
// module chunks = 27